import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MediaObserver } from '@angular/flex-layout';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PrivateProfile } from 'src/app/models/private-profile';
import { User } from 'src/app/models/user';
import { AlertService } from 'src/app/_services/alert.service';
import { DevicesService } from 'src/app/_services/devices.service';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { map } from 'rxjs/operators';
import { DocType } from 'src/app/models/doc-type';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-social-network-register',
  templateUrl: './social-network-register.component.html',
  styleUrls: ['./social-network-register.component.scss']
})
export class SocialNetworkRegisterComponent implements OnInit {

  public socialNetwRegForm: FormGroup;
  isRefered: any;
  sponsorId: string;
  validSponsor =  true;
  sponsorVerified = false;
  documentUsed = false;
  isValidDocument = false;
  sponsorDisplayName: string;
  sponsorEmail: string;
  emailReferente: any;
  termsAcepted = false;
  publicProfileUser: any;
  documentTypes: DocType[];
  selectedDocumentType: DocType;

  diviceXs: boolean;
  diviceSm: boolean;


  constructor(private fireStore: AngularFirestore, private firebaseAuthService: FirebaseAuthService, private afAuth: AngularFireAuth,
    private alertService: AlertService, public router: Router, private fb: FormBuilder, private userService: UserService,
    public mediaObserver: MediaObserver, private devicesService: DevicesService, private route: ActivatedRoute) {

              }

  ngOnInit(): void {

    this.route.data.subscribe((data: any) => console.log(data['user']));

    this.socialNetwRegForm = this.createSocialNetwRegForm();

    console.log(this.socialNetwRegForm);


    this.devicesService.dievice$.subscribe(res => {
      console.log("device",res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });

    this.loadDocumentTypes();

  }

  createSocialNetwRegForm(): FormGroup {

    return this.fb.group({
      documentType: ['CC', Validators.required],
      document: [ '' , [Validators.required, Validators.minLength(6)]],
      email: [this.firebaseAuthService.publicUserToCreate.email || '', Validators.required],
      fullName: [this.firebaseAuthService.publicUserToCreate.displayName || '', Validators.required],
      userName: [this.firebaseAuthService.publicUserToCreate.displayName || '', Validators.required],
      isRefered: [ ],
      emailSponsor: [],
      termsAndConditions: [],
      emailOffers: [false]
    });
  }

  async createUser(): Promise<any>{
    if (this.socialNetwRegForm.valid &&
      (this.sponsorVerified && this.isRefered || !this.isRefered) &&
      !this.documentUsed && this.isValidDocument ) {

      const publicFirebaseUser = {
        displayName: this.socialNetwRegForm.value.userName,
        termsAndConditions: true,
        rol: 'usuario',
        email: this.socialNetwRegForm.value.email
      };

      return this.fireStore.collection('users')
        .doc(this.firebaseAuthService.publicUserToCreate.uid)
        .set({
          ...publicFirebaseUser
        }).then(() => {
          const privateProfile = new PrivateProfile();
          privateProfile.sponsorId = (this.isRefered ? this.sponsorId : 'TuGessiAdminUser');
          privateProfile.sponsorDisplayName = (this.isRefered ? '' : 'TuGessi.com');
          privateProfile.sponsorEmail = (this.isRefered ? '' : 'desarrollo.tugessi@gmail.com');
          privateProfile.fullName = this.socialNetwRegForm.value.fullName;
          privateProfile.termsAndConditions = true;
          privateProfile.emailOffers = this.socialNetwRegForm.value.emailOffers;
          privateProfile.email = this.socialNetwRegForm.value.email;
          privateProfile.document = this.socialNetwRegForm.value.document.toString();
          privateProfile.documentType = this.socialNetwRegForm.value.documentType;
          privateProfile.displayName = this.socialNetwRegForm.value.userName;
          privateProfile.rol = 'usuario';

          this.fireStore.collection('users').doc(this.firebaseAuthService.publicUserToCreate.uid)
              .collection('privateProfile').add(
                {
                  ...privateProfile
                }
              );



        }).catch(error => {
          console.log(error);
        }).then( () => {
          // this.firebaseAuthService.addUserReferredToSponsorUser((this.isRefered ? this.sponsorId : 'TuGessiAdminUser'), publicFirebaseUser);
          this.firebaseAuthService.completeRegister = false;
          this.alertService.openAlertDialog('Registrado correctamente '
          + 'Bienvenido!', false, false);
          this.alertService.alertDialgoRef.afterClosed().subscribe(result => {
            this.firebaseAuthService.displayNameObs = this.firebaseAuthService.getPublicUserByEmail(this.firebaseAuthService.publicUserToCreate.email)
              .pipe(map(user => user ? user.displayName : null));
            console.log(result);
            this.router.navigate(['']);
          });
        });
    }
  }

  OnChekboxChange(e): void {
    this.isRefered = this.socialNetwRegForm.get('isRefered').value;
    if (this.isRefered ) {
      this.validSponsor = false;
    }
  }

  async verifySponsorExist(email: string): Promise<void> {
    this.firebaseAuthService.verifySponsor(email)
      .subscribe(answ => {
        console.log(answ);
        this.sponsorId = answ.toString();
        this.sponsorVerified = true;
        this.alertService.openAlertDialog('¡Patrocinador confirmado!', false, false);
      }, error => {
        this.sponsorVerified = false;
        if (error.error.message === 'Sponsor not found') {
          this.alertService.openAlertDialog('Por favor verifica el correo de la persona que te refirió', true, false);
        } else if (error.error.message === 'Not email confirmed') {
          this.alertService.openAlertDialog('El usuario no ha confirmado su cuenta, ¡por favor avísale!', true, false);
        } else {
          this.alertService.openAlertDialog('Error desconocido al verificar el correo del referido', true, false);
        }
      });
  }

  OnChekboxTemsCondChange(e): void{
    this.termsAcepted = this.socialNetwRegForm.get('termsAndConditions').value;
  }

  async verifyDocumentExists(): Promise<void>{
    this.firebaseAuthService.veryfyDocumentAvailable(this.socialNetwRegForm.value.document)
      .subscribe(anws =>
        {
        console.log(anws);
          if (anws.valid) {
            this.documentUsed = false;
            this.isValidDocument = true;
          } else {
            this.documentUsed = true;
            this.isValidDocument = false;
          }
        });
  }

  disableSubmmit(): void{
    this.isValidDocument = false;
  }

  loadDocumentTypes() {
    this.userService.getDocumentTypes().subscribe(documents => {
      this.documentTypes = documents;

      this.selectedDocumentType = this.documentTypes.find(doc => doc.name == 'CC');

    });
  }

  documentTypeSelection(docSelected) {

    this.selectedDocumentType = this.documentTypes.find(doc => doc.name == docSelected);

  }

}
